import { render, staticRenderFns } from "./templateId.vue?vue&type=template&id=2de53f26&scoped=true"
import script from "./templateId.vue?vue&type=script&lang=js"
export * from "./templateId.vue?vue&type=script&lang=js"
import style0 from "./templateId.vue?vue&type=style&index=0&id=2de53f26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de53f26",
  null
  
)

export default component.exports